var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.672 5.869-3.669 2.973c-.264-.628-1.705-2.042-5.354-2.677-3.65-.634-7.074 2.314-8.33 3.867 3.074-.132 9.36-.317 9.915 0 .694.397.794 1.388.397 2.082-.317.556-1.19 1.554-1.586 1.983H10.734v3.471h9.22c1.032-.001 1.158 1.453 1.092 2.18l-1.587 2.38h-7.14c.793 1.123 3.332 3.37 7.14 3.37 3.807 0 5.948-1.85 6.543-2.776l3.669 2.777c-.628 1.025-2.4 3.213-4.462 3.768-2.578.694-7.536 1.488-12.295-.694-3.807-1.745-5.883-5.023-6.445-6.444H4.29c-.715 0-1.158-.926-1.29-1.389l1.29-3.171h.891v-3.472H3.794C3.53 13.867 3 13.285 3 12.81c0-.477.86-2.314 1.29-3.174h2.18C6.9 8.91 8.057 7.138 9.247 5.87 10.734 4.28 12.915 2.099 19.955 2c5.632-.08 8.824 2.545 9.717 3.867z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.1fc05f6ad81ed77cb758988399993d2c.svg";
export { ForwardRef as ReactComponent };